import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { fetchBranchReport, timeout } from "../Managers/wepApiManager";
import {
  BranchReportModel,
  EnumAlertDialogType,
} from "../Managers/dataStructures";
import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  processBranchCSVReportForAdmin,
  processDownloadReport,
} from "../Managers/processManager";
import {
  ActivityIndicator,
  PositiveToast,
  NegativeToast,
} from "../Managers/utilityComponents";
import {
  dateToString,
  dateToStringForPicker,
} from "../Managers/utilityFunctions";
import { currentDateFormat, getLanguage } from "../Managers/dataProvider";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFReportAllBranch from "./PDFReportAllBranch";
import AdminDetailBranchReport from "./AdminDetailBranchReport";

//import de from "date-fns/locale/de";
// with date-fns v3.x or v4.x
//import { de } from "date-fns/locale/de";

export default function AdminBranchReport() {
  const isEnglish = getLanguage();
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [activityIndicator, setActivityIndicator] = useState<boolean>(false);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [csvIndicator, setCSVIndicator] = useState<boolean>(false);
  const [isToastVisible, setIsToastVisible] = useState<EnumAlertDialogType>(
    EnumAlertDialogType.NEUTRAL
  );
  const [array_reports, setArrayReports] = React.useState<BranchReportModel[]>(
    []
  );
  //const locales = ["en", "en-gb", "zh-cn", "de"];
  useEffect(() => {
    setActivityIndicator(true);
    fetchBranchReport(
      startDate,
      endDate,
      (array_repos: BranchReportModel[]) => {
        setArrayReports(array_repos);
        setActivityIndicator(false);
      }
    );
  }, [startDate, endDate]);

  const startDateString: string = dateToString(startDate);
  const endDateString: string = dateToString(endDate);
  const startDateStringForPicker: string = dateToStringForPicker(startDate);
  const endDateStringForPicker: string = dateToStringForPicker(endDate);
  const reportName: string =
    "Report All Branches-From " +
    startDateString +
    " to " +
    endDateString +
    ".pdf";

  function onStartDateChange(x: dayjs.Dayjs | null) {
    setStartDate(x?.toDate() as Date);
  }

  function onEndDateChange(x: dayjs.Dayjs | null) {
    setEndDate(x?.toDate() as Date);
  }

  async function onDownload() {
    setIsRunning(true);
    onCreatePDF();

    //ReactPDF.render(<PDFReportAllBranch />, `example.pdf`);
    //ReactPDF.renderToStream(<PDFReportAllBranch />);

    await processDownloadReport();
    showAlert(true);
    setIsRunning(false);
  }

  async function onDownloadCSV() {
    setCSVIndicator(true);
    downloadCSV();
    await processDownloadReport();
    showAlert(true);
    setCSVIndicator(false);
  }

  function downloadCSV() {
    const reportName: string =
      "Report All Branches-From " +
      startDateString +
      " to " +
      endDateString +
      ".csv";
    const element = document.createElement("a");
    const file = new Blob(
      [
        processBranchCSVReportForAdmin(
          array_reports,
          startDateString,
          endDateString
        ),
      ],
      {
        type: "text/plain",
      }
    );
    element.href = URL.createObjectURL(file);
    element.download = reportName;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  function onCreatePDF() {
    const planName: string =
      "Report All Branches-From " +
      startDateString +
      " to " +
      endDateString +
      ".pdf";
    const input = document.getElementById("divToPrint");
    let formatHeight: number = 4;
    formatHeight = array_reports.length * 100;
    if (input !== null) {
      html2canvas(input, { scale: 2 }).then((canvas) => {
        /*
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: formatHeight < 500 ? "landscape" : "portrait",
          unit: "px",
          format: [500, formatHeight / 1.5],
        });
        pdf.addImage(
          imgData,
          "JPEG",
          0,
          0,
          500,
          formatHeight / 2,
          planName,
          "SLOW"
        );
        pdf.save(planName);
        */
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: formatHeight < 500 ? "landscape" : "portrait",
          unit: "px",
          format: "a4",
        });
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(planName);
      });
    }
  }

  async function showAlert(isPositive: boolean) {
    if (isPositive) {
      setIsToastVisible(EnumAlertDialogType.POSITIVE);
    } else {
      setIsToastVisible(EnumAlertDialogType.NEGATIVE);
    }
    await timeout(3000);
    setIsToastVisible(EnumAlertDialogType.NEUTRAL);
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish
              ? "Report : All Branches"
              : "Bericht Alle Filialen Seite"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? "Summary of total working hours of all branches from selected timespan."
              : "Zusammenfassung der gesamten Arbeitsstunden, die pro Filiale für den ausgewählten Zeitraum erfasst wurden"}
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none"></div>
      </div>
      <div className="mt-2 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="px-8 mt-4 sm:flex mr-5">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label={isEnglish ? "From" : "Von"}
                  disableFuture
                  format={currentDateFormat()}
                  onAccept={(x) => onStartDateChange(x)}
                  defaultValue={dayjs(startDateStringForPicker)}
                  disabled={activityIndicator}
                />
              </DemoContainer>
            </LocalizationProvider>
            <div className="mx-2">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label={isEnglish ? "To" : "Bis"}
                    disableFuture
                    format={currentDateFormat()}
                    onAccept={(x) => onEndDateChange(x)}
                    defaultValue={dayjs(endDateStringForPicker)}
                    disabled={activityIndicator}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          </div>
          {activityIndicator === true ? (
            <div className="mt-5 flex items-center justify-center">
              {ActivityIndicator(1)}
            </div>
          ) : array_reports.length === 0 ? (
            <div className="mt-10 flex justify-center font-semibold">
              {isEnglish ? "No Report Available" : "Keine Berichte verfügbar."}
            </div>
          ) : (
            <div>
              <div className="mt-4 mx-8 sm:mt-0 sm:flex-none flex items-center gap-x-6">
                <PDFDownloadLink
                  document={
                    <PDFReportAllBranch
                      array_reports={array_reports}
                      startDateString={startDateString}
                      endDateString={endDateString}
                    />
                  }
                  fileName={reportName}
                >
                  <button
                    type="button"
                    //onClick={onDownload}
                    className="block rounded-md mt-5 bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    {isRunning === true ? ActivityIndicator(0) : null}
                    {isEnglish ? "Download PDF" : "Download PDF"}
                  </button>
                </PDFDownloadLink>
                <button
                  type="button"
                  onClick={onDownloadCSV}
                  className="block rounded-md mt-5 bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  {csvIndicator === true ? ActivityIndicator(0) : null}
                  {isEnglish ? "Download CSV" : "Download CSV"}
                </button>
              </div>
              <div id="divToPrint" className="mx-8 h-[1024px]">
                <div className="mt-5 px-2 sm:px-2 lg:px-2">
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    {isEnglish ? "Report : All Branches" : ""}
                  </label>
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    {(isEnglish ? "From : " : "Von : ") + startDateString}
                  </label>
                  <label className="block text-sm font-medium leading-6 text-gray-900">
                    {(isEnglish ? "To : " : "Bis : ") + endDateString}
                  </label>
                </div>
                <div className="col-span-full mt-4">
                  {isToastVisible === EnumAlertDialogType.NEUTRAL
                    ? null
                    : isToastVisible === EnumAlertDialogType.POSITIVE
                    ? PositiveToast(
                        isEnglish
                          ? "Report Downloaded"
                          : "Bericht heruntergeladen"
                      )
                    : NegativeToast(
                        isEnglish
                          ? "Error: Unable to process request."
                          : "Fehler: Anfrage kann nicht verarbeitet werden."
                      )}
                </div>
                {activityIndicator ? (
                  <div className="mt-5 flex items-center justify-center">
                    {ActivityIndicator(1)}
                  </div>
                ) : null}
                <div className="h-full">
                  <AdminDetailBranchReport array_reports={array_reports} />
                  {/* <PDFViewer style={{ height: "100%", width: "100%" }}>
                    <PDFReportAllBranch
                      array_reports={array_reports}
                      startDateString={startDateString}
                      endDateString={endDateString}
                    />
                  </PDFViewer> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
